// extracted by mini-css-extract-plugin
export var body = "_lm-0";
export var sectionHeader = "_lm-4";
export var shortcutColumns = "_lm-2";
export var shortcutList = "_lm-1";
export var shortcutSection = "_lm-3";